<!-- We are only using a one way databinding [] for value, and not a two-way binding [()] because the click action function will update the `pipelineView` value itself -->
<mat-button-toggle-group [value]="pipelineView">
  <mat-button-toggle value="default-table" (click)="navigateToTable()">
    <mat-icon fontSet="material-icons-sharp">table_rows</mat-icon>
    {{ 'FRONTEND.SALES_UI.PIPELINE.PIPELINE_BOARD.TABLE' | translate }}
  </mat-button-toggle>

  <mat-button-toggle value="default-board" (click)="navigateToBoard()">
    <mat-icon fontSet="material-icons-sharp">grid_view</mat-icon>
    {{ 'FRONTEND.SALES_UI.PIPELINE.PIPELINE_BOARD.BOARD' | translate }}
  </mat-button-toggle>
</mat-button-toggle-group>
